/* eslint-disable sort-keys */
import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers([
  'inStockFlex',
  'dotWrap',
  'dotInStock',
  'inStockText',
  'lowStockFlex',
  'dotLowStock',
  'lowStockText',
  'outOfStockFlex',
  'dotOutOfStock',
  'outOfStockText',
  'notifyMeButton',
]);

const statusFlex = {
  alignItems: 'center',
  gap: 2,
  marginTop: 1,
};

const dotWrap = {
  alignItems: 'center',
  display: 'flex',
  flexShrink: 0,
  height: '20px',
  justifyContent: 'center',
  width: '20px',
};

const statusText = {
  fontFeatureSettings: "'lnum' 1, 'pnum' 1",
  fontSize: {base: '16px', lg: '18px'},
  fontWeight: '500',
  lineHeight: {base: '1.4', lg: '1.2'},
  wordBreak: 'break-word',
};

const stripStatusText = {
  color: 'success.dark',
  fontFeatureSettings: "'lnum' 1, 'pnum' 1",
  fontSize: '12px',
  fontWeight: '400',
  lineHeight: '1.2',
  wordBreak: 'break-word',
};

const dotBreathingAnimation = {
  '@keyframes breathing': {
    '0%, 100%': {
      opacity: 1,
      transform: 'scale(1)',
    },
    '50%': {
      opacity: 0.5,
      transform: 'scale(0.85)',
    },
  },
  animation: 'breathing 2s ease-in-out infinite',
};

const ProductStockIndicator = helpers.defineMultiStyleConfig({
  baseStyle: {
    inStockFlex: statusFlex,

    dotWrap,

    dotInStock: {
      backgroundColor: 'success.standard',
      borderRadius: '50%',
      height: '10px',
      sx: dotBreathingAnimation,
      width: '10px',
    },

    inStockText: {
      ...statusText,
      color: 'success.dark',
    },

    lowStockFlex: statusFlex,

    dotLowStock: {
      backgroundColor: 'warning.standard',
      borderRadius: '50%',
      height: '10px',
      width: '10px',
    },

    lowStockText: {
      ...statusText,
      color: 'warning.dark',
    },

    outOfStockFlex: statusFlex,

    dotOutOfStock: {
      backgroundColor: 'error.standard',
      borderRadius: '50%',
      height: '10px',
      sx: dotBreathingAnimation,
      width: '10px',
    },

    outOfStockText: {
      ...statusText,
      color: 'error.dark',
    },

    notifyMeButton: {
      marginLeft: 2,
      textDecoration: 'underline',
    },
  },
  variants: {
    strip: {
      inStockText: stripStatusText,
      lowStockText: {
        ...stripStatusText,
        color: 'warning.dark',
      },
      outOfStockText: {
        ...stripStatusText,
        color: 'error.dark',
      },
    },
  },
  defaultProps: {
    variant: 'default',
  },
});

export default ProductStockIndicator;
